var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Choise',{attrs:{"value":_vm.value},on:{"update":function($event){return _vm.$emit('update', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }